import { KgbSuccessPage } from '@frontend/components/elements/KgbSuccessPage';

export function OrderSuppliesSuccess() {
    const successText = (
        <>
            We hebben je bestelling ontvangen en gaan ermee <br />
            aan de slag. Je krijgt een bevestiging per e-mail.
            <br />
            <br />
            Heb je vragen? Neem gerust contact met ons op.
        </>
    );

    return (
        <KgbSuccessPage
            buttonText="Ga terug naar home"
            linkTo="/"
            text={successText}
            title="Je bestelling is geplaatst!"
        />
    );
}
